import { useEffect } from 'react';
import L from 'leaflet';
import './Map.css';
import mapMarkerImg from '../assets/images/map-marker.png';

interface Props {
    location: any
}
const Map = (props: Props) => {
    useEffect(() => {
        if (props.location.length) {
            const mapOptions = {
                center: [props.location[0], props.location[1]],
                zoom: 14,
            } as any;
            setTimeout(() => {
                const myIcon = L.icon({
                    iconUrl: mapMarkerImg,
                    iconSize: [30, 43],
                    iconAnchor: [15, 43]
                });
                const mapEl = document.getElementById('mapContainer');
                if (mapEl) {
                    mapEl.innerHTML = "<div id='map' style='width: 100%; height: 100%;'></div>";
                    const map = L.map('map', mapOptions);
                    L.marker(mapOptions.center, { icon: myIcon }).addTo(map).bindPopup('طاهاگشت');
                    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                        maxZoom: 19,
                        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    }).addTo(map);
                }
            }, 100);
        }
    }, [props.location]);
    return (
        <div id="mapContainer" className="map-container">
            <div className="ring1">
                <div className="ring2">
                    <div className="ring3"></div>
                </div>
            </div>
        </div>
    );
};
export default Map;